<script lang="ts" setup>
const paymentTypes = [
  {
    title: 'Банковской картой онлайн*',
    desc: 'Мы принимаем VISA, Mastercard, МИР. Также внедряем Apple Pay и Google Pay**',
    img: '/card-online.webp',
  },
  {
    title: 'Оплата картой курьеру*',
    desc: 'Курьер приедет с терминалом. Мы принимаем VISA, Mastercard, МИР',
    img: '/card.webp',
  },
  {
    title: 'Наличными курьеру',
    desc: 'Если вы указали в корзине, что необходима сдача, курьер приедет с нужной суммой',
    img: '/cash.webp',
  },
]
</script>

<template>
  <ul class="payment-types">
    <li
      v-for="paymentType in paymentTypes"
      :key="paymentType.title"
      class="payment-types__item"
    >
      <div class="payment-types__image-wrapper">
        <nuxt-img
          :src="paymentType.img"
          :alt="paymentType.title"
          class="payment-types__image"
          fit="contain"
          format="webp"
        />
      </div>

      <div class="payment-types__text">
        <div class="payment-types__title">
          {{ paymentType.title }}
        </div>

        <div class="payment-types__description">
          {{ paymentType.desc }}
        </div>
      </div>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.payment-types {
  padding: 0;
  list-style-type: none;
  @include media('>=desktop-mini') {
    display: flex;
    gap: 50px;
    justify-content: center;
  }

  &__item {
    display: flex;
    gap: 15px;
    margin-bottom: 20px;
    &:nth-child(odd) {
      flex-direction: row-reverse;
    }
    @include media('>=desktop-mini') {
      flex: 0 1 100%;
      flex-direction: column;
      gap: 0;
      align-items: center;
      max-width: 290px;
      margin-bottom: 0;
      font-size: 16px;
      &:nth-child(odd) {
        flex-direction: column;
      }
    }
  }

  &__text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 50%;
    @include media('>=desktop-mini') {
      width: auto;
      text-align: center;
    }
  }

  &__title {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 800;
    color: var(--ui-text-primary);
  }

  &__description {
    font-size: 14px;
    font-weight: 600;
    color: var(--ui-text-primary);
  }

  &__image-wrapper {
    width: 50%;
    height: auto;
    text-align: center;
    @include media('>=desktop-mini') {
      margin-bottom: 30px;
    }
  }

  &__image {
    width: 100%;
    max-width: 168px;
  }
}
</style>
